import { render, staticRenderFns } from "./newsletter-list-filter.vue?vue&type=template&id=1c632554&"
import script from "./newsletter-list-filter.vue?vue&type=script&lang=js&"
export * from "./newsletter-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports